import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=0387dca8&"
import script from "./SearchResult.vue?vue&type=script&lang=js&"
export * from "./SearchResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports